import functions from "./functions.js";

$(function () {

    const $form = $('.booking-form');
    const form = $form[0];

    if (!form) {
        return;
    }

    const booking = {
        $form: null,
        $payment: null,
        $calculation: null,
        calc: [],
        persons: null,
        promoDiscount: null,
        totalAmount: null,
        totalAmountConverted: null,
        insurance: null,
        status: null,

        init() {

            // BOOKING PAYMENT TYPE CHECKBOX
            if($('[name="paymentType"]')[0]) {
                checkPaymentType();
                $('[name="paymentType"]').on('change', e => {
                    checkPaymentType();
                });

                function checkPaymentType() {
                    $('[name="paymentType"]').each((index, item) => {
                        const $item = $(item);
                        const id = $item.attr('id');
                        $('[for=' + id + ']').find('[id='  + id + ']').prop('checked', $item.is(':checked'));
                    });
                }
            }

            let termsUrl = $('[data-termsurl]').attr('data-termsurl') || null;
            let privacyUrl = $('[data-privacyurl]').attr('data-privacyurl') || null;

            if(termsUrl) {
                let html = '';
                $.get(termsUrl).done(response => {
                    html = $('<div>' + response + '</div>').find('.wp-block-custom-gutenberg-container');
                    $('.booking-form').find('.term-text').html(html);
                });
            }

            if(privacyUrl) {
                let html = '';
                $.get(privacyUrl).done(response => {
                    html = $('<div>' + response + '</div>').find('.wp-block-custom-gutenberg-container');
                    $('.booking-form').find('.privacy-text').html(html);
                });
            }

            $('.text-to-agree').on('scroll', e => {
                if ($('.text-to-agree').scrollTop() > 10)
                    {
                         $('#agree').attr('disabled', false);
                         $('#agree').removeClass('disabled');
                    }
                
            })
           

            booking.$form = $(".booking-form");
            booking.$calculation = $(".table-calculation");
            booking.$payment = $(".payment-details");
            booking.params = {};

            booking.$calculation.find("*[data-calc]").each(function (index) {
                let item = JSON.parse($(this).attr('data-calc'));
                item.inCalc = item.isOptional ? 0 : 1;
                booking.calc.push(item);
            });

            $('.booking-page').on('change', 'input[type="checkbox"]', function (e) {
                let $row = $(e.currentTarget).closest('.calc-item');
                let $quantity = $row.find('[name=quantity]');
                let value = +$quantity.val();
                let checked = $(e.currentTarget).is(':checked') ? 1 : 0;

                if (checked && !value) {
                    $quantity.prop('value', 1);
                } else if (!checked && value) {
                    $quantity.prop('value', 0);
                }

                booking.calculate($(e.currentTarget));
            });

            $('.booking-page').on('change', 'select.quantity', function (e) {
                let $row = $(e.currentTarget).closest('tr');
                let $checkbox = $row.find('input[type="checkbox"]');
                let value = +$(e.currentTarget).val();

                if (value && !$checkbox.is(':checked')) {
                    $checkbox.prop('checked', true);
                } else if (!value && $checkbox.is(':checked')) {
                    $checkbox.prop('checked', false);
                }

                booking.calculate($(e.currentTarget));
            });

            booking.total();

            $('.booking-page').on('submit', '.booking-form', e => {

                if ($('#agree').hasClass('disabled'))
                {
                    e.preventDefault();
                    return
                }

                let $passangers = $('.passenger-entry');

                $passangers.each((index, form) => {
                    let $form = $(form);
                    if ( ! $form[0].checkValidity()) {
                        
                        var tmpSubmit = document.createElement('button');
                        $form[0].appendChild(tmpSubmit);
                        tmpSubmit.click();
                        $form[0].removeChild(tmpSubmit);

                        e.preventDefault();
                        return;
                    }
                })
               

                $('button[type="submit"]').attr('disabled', 'disabled');

                booking.submit();
            });

            const $partnerCodeSuccess = $(".promoCodeSuccess");
            const $partnerCodeError = $(".promoCodeError");

            booking.$pricingContainer = $(".table-calculation");
            $('#promoCodeApply').on('click', function (e) {
                let params = {};
                params['language'] = functions.getLang();
                params['promoCode'] = $("input[name='promoCode']").val();

                $.post('/services/promoCode/', params).then(response => {
   
                    response = JSON.parse(response);


                    $(".promo-code-output").removeClass('d-none').html(response.data);
                    if (response.status == true) {
                        $("#promoCodeApply").attr('disabled', true);
                        $partnerCodeSuccess.removeClass('d-none');
                        booking.applyDiscount(response);
                    }
                    else
                    {
                        $partnerCodeError.removeClass('d-none');
                    }

                    setTimeout(() => {
                        $partnerCodeSuccess.addClass('d-none');
                        $partnerCodeError.addClass('d-none');
                    }, 5000);
                });
                
            });

            // recalculate if guests birthDates are different than in initial calc
            $('.guests select[name]').on('change', function (e) {
                const $guestsRow = $(this).closest('.guests');
                const calcId = $guestsRow.attr('data-guests-parentid');
                let calc = booking.calc.find((calc, i) => calc.calcId == calcId);
                if ( !calc ) {
                    calc = functions.getUrlData(false);
                    calc.cart_data = JSON.parse(calc.cart_data);
                    calc = calc.cart_data[calcId-1];
                }
                const dateFrom = calc.dateFrom;
                const guests = (calc.guests || '').split(',');
                const adults = +guests[0];
                const children = +guests[1] || 0;
                const childrenAges = guests.slice(2, 2+ children).sort((a,b) => a < b ? 1 : -1);
                
                let _adults = 0;
                let _childrenAges = [];
                $guestsRow.find('[data-guests]').map((i, elem) => {
                    let year = (+$guestsRow.find('select[name="birthDateYear' + i + '"]').val() || '') + '';
                    let month = (+$guestsRow.find('select[name="birthDateMonth' + i + '"]').val() || '') + '';
                    let day = (+$guestsRow.find('select[name="birthDateDay' + i + '"]').val() || '') + '';
                    if ( year && month && day ) {
                        let age = new Date(new Date(dateFrom) - new Date(`${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`)).getFullYear() - 1970;
                        if ( age >= 18 ) {
                            _adults++;
                        } else {
                            _childrenAges.push(String(age));
                        }
                    }
                });
                _childrenAges.sort((a,b) => a < b ? 1 : -1);
                // continue only if all guests are populated
                if ( (adults + childrenAges.length) == (_adults + _childrenAges.length) ) {
                    // AND different from initial guests
                    if ( adults != _adults || childrenAges.join(',') != _childrenAges.join(',') ) {
                        let newGuests = `${_adults},${_childrenAges.length}${_childrenAges.length ? ',' + _childrenAges.join(',') : ''}`;
                        let params = booking.recalculateParams || functions.getUrlData(false);
                        params.cart_data = JSON.parse(params.cart_data);
                        params.cart_data[calcId-1].guests = newGuests;
                        params.cart_data = JSON.stringify(params.cart_data);
                        params.language = functions.getLang();
                        booking.recalculateParams = params;
                        $.get('/services/booking_form_cart/', $.param(booking.recalculateParams)).then(response => {
                            if ( response ) {
                                response = JSON.parse(response)
                                $('.cart-booking').html(response.html);
                                booking.calc = [];
                                booking.$form = $(".booking-form");
                                booking.$calculation = $(".table-calculation");
                                booking.$calculation.find("*[data-calc]").each(function (index) {
                                    let item = JSON.parse($(this).attr('data-calc'));
                                    item.inCalc = item.isOptional ? 0 : 1;
                                    booking.calc.push(item);
                                });
                                booking.total();
                                booking.$payment = $(".payment-details");
                                window.observer.observe();
                                $("#promoCodeApply").attr('disabled', false);
                                confirm('Zbog promjena u godinama gostiju došlo je do novog obračuna.\nProvjerite prije nego što nastavite.');
                                /*$('.guests-recalculate')
                                    .removeClass('d-none')
                                    .delay(6000).queue(function () {
                                        $(this).addClass('d-none');
                                    });*/
                            }
                        });
                    }
                }
            });

        },
        submit() {
            $.each(booking.calc, function(key, item) {
                if ( ! item.inCalc) {
                    delete booking.calc[key];
                } else if (item.itemDefinitionId.categoryId.key == 'baseRate') {
                    let $guestsPerProduct = $("[data-guests-parentId='" + item.calcId + "']");
                    let guests = [];

                    if ($guestsPerProduct.length) {
                        $guestsPerProduct.find('[data-guests]').each(function (index) {
                            let g = +$(this).data('guests');
                            guests[index] = {
                                firstName : $(this).find("input[name='guestFirstName" + g + "']").val(),
                                lastName : $(this).find("input[name='guestLastName" + g + "']").val(),
                                birthDate : $(this).find("*[name='birthDateYear" + g + "']").length ? $(this).find("*[name='birthDateYear" + g + "']").val() + '-' + $(this).find("*[name='birthDateMonth" + g + "']").val() + '-' + $(this).find("*[name='birthDateDay" + g + "']").val() : null,
                                gender : $(this).find("*[name='gender" + g + "']").length ? $(this).find("*[name='gender" + g + "']").val() : null,
                            };
                        });
                        booking.calc[key].guestsData = guests;
                    }
                }
            });

            booking.params.paymentType = booking.$payment.find("[name='paymentType']:checked").val() ? booking.$payment.find("[name='paymentType']:checked").val() : 'bankTransfer';
            if (booking.params.paymentType == 'allAtOnce')
            {
                booking.params.paymentMethod = 'full';
                booking.params.paymentType = 'creditCard';
            }
            booking.params.calc = JSON.stringify(booking.calc);
            booking.params.requestId = Math.floor(Math.random() * ((9999999 - 1000000) + 1) + 1000000);

            booking.params.partnerId = booking.$form.attr('data-partnerid');

            $.each(booking.params, function (key, param) {
                $('<input>').attr({
                    type: 'hidden',
                    name: key,
                    value: param
                }).appendTo(booking.$form);
            });

        },
        calculate($elem) {
            let $row = $elem.closest('.calc-item');

            let $checkbox = $row.find('input[type="checkbox"]');
            let checked = $checkbox.is(':checked') ? 1 : 0;
            let id = $checkbox.attr('id');

            let $quantity = $row.find('select.quantity:visible');
            let quantity = null;

            if ($quantity.length) {
                quantity = +$quantity.val();
            }

            $.each(booking.calc, function (key, calc) {
                if (calc.id == id) {

                    if (quantity == null) {
                        quantity = booking.calc[key].quantity;
                    }

                    booking.calc[key].inCalc = checked;
                    booking.calc[key].quantity = (quantity || 1);
                    booking.calc[key].total = booking.itemTotal(booking.calc[key]);
                    booking.calc[key].totalConverted = booking.itemTotalConverted(booking.calc[key]);

                    $row.find('.item-total-amount').html(functions.formatMoney(booking.calc[key].total, 2, ',', '.'));
                    $row.find('.item-total-amount-converted').html(functions.formatMoney(booking.calc[key].totalConverted, 2, ',', '.'));
                }
            });


            booking.total();
        },
        itemTotal(item) {
            let itemTotal = 0.00;

            if (item.paymentTypeId.key) {

                if ($.inArray(item.paymentTypeId.key, ['perPerson', 'perPersonPerDay', 'perPersonPerWeek', 'Once']) > -1) {
                    itemTotal = +item.quantity * +item.price;
                } else {
                    itemTotal = +item.price;
                }
            } else {
                itemTotal = +item.quantity * +item.price;
            }

            return itemTotal;
        },
        itemTotalConverted(item) {
            let itemTotal = 0.00;

            if (item.paymentTypeId.key) {

                if ($.inArray(item.paymentTypeId.key, ['perPerson', 'perPersonPerDay', 'perPersonPerWeek', 'Once']) > -1) {
                    itemTotal = +item.quantity * +item.priceConverted;
                } else {
                    itemTotal = +item.priceConverted;
                }
            } else {
                itemTotal = +item.quantity * +item.priceConverted;
            }

            return itemTotal;
        },
        total() {
            const $e = $('.payment-details');

            const advancePaymentPercent = $e.attr('data-advancepaymentpercent');
            const commissionForCreditCard = +$e.attr('data-commissionforcreditcard');

            let totalAmount = 0.00;
            let totalAmountConverted = 0.00;

            $.each(booking.calc, function (key, calc) {
                if (!calc.onSpot && calc.inCalc) {
                    console.log(booking.itemTotal(calc));
                    totalAmount += booking.itemTotal(calc);
                    totalAmountConverted += booking.itemTotalConverted(calc);
                }
            });

            let _advance = totalAmount * (advancePaymentPercent / 100);
            let _rest = totalAmount - _advance;

            let totalAmountCard = totalAmount + ((totalAmount * commissionForCreditCard ) / 100);
            let totalAmountCardConverted = totalAmountConverted + ((totalAmountConverted * commissionForCreditCard ) / 100);

            let advanceCard = totalAmountCard * (advancePaymentPercent / 100);
            let restCard = totalAmountCard - advanceCard;
            let advanceCardConverted = totalAmountCardConverted * (advancePaymentPercent / 100);
            let restCardConverted = totalAmountCardConverted - advanceCardConverted;

            let advance = totalAmount * (advancePaymentPercent / 100);
            let rest = totalAmount - advance;
            let advanceConverted = totalAmountConverted * (advancePaymentPercent / 100);
            let restConverted = totalAmountConverted - advanceConverted;

            $('.cart-total-amount').html(functions.formatMoney(totalAmount, 2, ',', '.'));
            $('.cart-total-amount-converted').html(functions.formatMoney(totalAmountConverted, 2, ',', '.'));

            $("#credit-card-card-body").find('.advance').html(functions.formatMoney(_advance, 2, ',', '.'));
            $("#credit-card-card-body").find('.rest').html(functions.formatMoney(_rest, 2, ',', '.'));
            $("#bank-transfer-card-body").find('.advance').html(functions.formatMoney(advance, 2, ',', '.'));
            $("#bank-transfer-card-body").find('.rest').html(functions.formatMoney(rest, 2, ',', '.'));

            $("#all-now-card-body").find('.advance').html(functions.formatMoney(advanceCard + restCard, 2, ',', '.'));


            $("#credit-card-card-body").find('.advance-converted').html(functions.formatMoney(advanceCardConverted, 2, ',', '.'));
            $("#credit-card-card-body").find('.rest-converted').html(functions.formatMoney(restCardConverted, 2, ',', '.'));
            $("#bank-transfer-card-body").find('.advance-converted').html(functions.formatMoney(advanceConverted, 2, ',', '.'));
            $("#bank-transfer-card-body").find('.rest-converted').html(functions.formatMoney(restConverted, 2, ',', '.'));

        },

        applyDiscount(promoCode) {
            booking.$calculation.each(function (index, elem) {
                $(this).find(".promoDiscountItem").remove();
                let promoDiscountItem = JSON.parse($(this).find("*[data-calc]:first").attr('data-calc'));
                let promoDiscountItemId = promoDiscountItem.id + '_' + 114;

                let total = 0;
                let totalConverted = 0;
                $(this).find("*[data-calc]").each(function (index) {
                    let item = JSON.parse($(this).attr('data-calc'));
                    let quantity = item.isOptional ? $(this).find('select.quantity').val() : item.quantity;
                    if ( ! item.onSpot && quantity) {
                        total += +item.price * +quantity;
                        totalConverted += +item.priceConverted * +quantity;
                    }
                });

                $.each(booking.calc, function (key, calc) {
                    if (calc && calc.id == promoDiscountItemId) {
                        booking.calc.splice(key, 1);
                    }
                });

                let discountAmount = (-1 * (total * (promoCode.percent/100)));
                let discountAmountConverted = (-1 * (totalConverted * (promoCode.percent/100)));

                promoDiscountItem.id = promoDiscountItemId;
                promoDiscountItem.itemDefinitionId.id = 114;
                promoDiscountItem.itemDefinitionId.text = 'Promo Kod Popust';
                promoDiscountItem.itemTitle = {
                    name_hr:'Promo Kod Popust',
                };

                promoDiscountItem.quantity = 1;
                promoDiscountItem.itemDefinitionId.categoryId.id = 80;
                promoDiscountItem.itemDefinitionId.categoryId.key = 'discount';
                promoDiscountItem.itemDefinitionId.objectGroupId.id = 1;
                promoDiscountItem.itemDefinitionId.objectGroupId.key = 'accommodation';
                promoDiscountItem.itemDefinitionId.typeId.id = 3;
                promoDiscountItem.itemDefinitionId.typeId.key = 'discount';
                promoDiscountItem.priceIn = discountAmount;
                promoDiscountItem.price = discountAmount;
                promoDiscountItem.totalIn = discountAmount;
                promoDiscountItem.total = discountAmount;
                promoDiscountItem.priceConverted = discountAmountConverted;
                promoDiscountItem.skipCalculate = true;


                $(elem).find('tbody .calc-item:first-child').after('<tr class="promoDiscountItem calc-item" data-calc=\'' + JSON.stringify(promoDiscountItem) + '\'>\n' +
                '        <td class="ps-1">\n' +
                '            <span class="custom-control custom-checkbox">\n' +
                '                <input type="checkbox" class="custom-control-input" id="' + promoDiscountItem.id + '" name="' + promoDiscountItem.id + '" checked="" disabled="">\n' +
                '            </span>\n' +
                '            \n' +
                '        </td>\n' + '<td><span class="fw-bold">'+ promoDiscountItem.itemDefinitionId.text +'</label></td><td class="text-center">1</td>' +
                '        <td class="text-end">€' + functions.formatMoney(discountAmount, 2, ',', '.') + ' ' +
                '        </td>' +
                '        <td class="text-end pe-1">\n' +
                '          € <span class="">' + functions.formatMoney(discountAmount, 2, ',', '.') + '</span>\n' +
                '        </td>\n' +
                '    </tr>')

                booking.calc.push(promoDiscountItem);
                booking.calculate($(this).find(".promoDiscountItem"));
            });

        },
    }

    booking.init();
});